import React from 'react';
import FigurePreview from '../shared/FigurePreview';
import StepActions from '../shared/StepActions';
import StepShell from '../shared/StepShell';
import { pageImage } from '../shared/wizardUtils';

export default function ShowContoursStep({ grave, onNext, onCancel }) {
  return (
    <StepShell>
      <h3>Show Contours</h3>
      <div className="alert alert-primary">Verify that the grave cut contour is included.</div>
      <FigurePreview figures={[grave]} image={pageImage(grave)} showContours />
      <StepActions onNext={onNext} onCancel={onCancel} />
    </StepShell>
  );
}
